import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW6100Model } from './kymw6100.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { GetCwsUseImageInfoService } from './api-services/get-cws-use-image-info.service';
import { PutImageFileService } from './api-services/put-image-file.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';

/**
 * EC画像指示一覧表画面を管理するクラス
 *
 * @export KYMW6100Component
 * @class KYMW6100Component
 */
@Component({
  selector: 'app-kymw6100',
  templateUrl: 'kymw6100.component.html',
  styleUrls: ['kymw6100.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW6100Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txta_FileNameList', { static: true }) txta_FileNameList: ElementRef;
  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderCodeTextInputComponent;

  // 親画面からの連携値
  param: any;

  kymw6100Model: KYMW6100Model = new KYMW6100Model();

  /**
   *Creates an instance of KYMW6100Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {GetCwsUseImageInfoService} getCwsUseImageInfoService
   * @param {PutImageFileService} putImageFileService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW6100Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private getCwsUseImageInfoService: GetCwsUseImageInfoService,
    private putImageFileService: PutImageFileService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW6100';
    document.getElementById('txta_FileNameList').addEventListener('input', () => this.eventFileNameListHandler());

    setTimeout(() => {
      this.plessEnabledSetting();
    });
  }

  public plessEnabledSetting() {
    this.initKYMW6100();
  }

  /**
   * 画像指示一覧ボタン、または画像ファイルボタンを押下した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventImageFile_enabled(): void {
    // 「2：画像ファイル」の場合
    if (this.kymw6100Model.radioGroup === '2') {
      this.plessEnabled(this.txti_OrderCode, false);
      this.plessEnabled(this.txta_FileNameList, true);
      // 受注コードをクリアに連動して、配達企画回（翌週）がクリアされる。
      this.kymw6100Model.orderCode = '';

      // 上記以外の場合
    } else {
      this.plessEnabled(this.txti_OrderCode, true);
      this.plessEnabled(this.txta_FileNameList, false);
      // 画像ファイル名リスト
      this.kymw6100Model.fileNameList = '';
    }
  }

  /**
   * 画像ファイル名リストに入力した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventFileNameListHandler(): void {
    const array: any = PlessViewUtilsSub.formatList(this.kymw6100Model.fileNameList.split('\n'), 500);
    this.kymw6100Model.fileNameList = PlessViewUtilsSub.arrayToString(array, '\n');
  }

  /**
   * 出力ボタンを押下した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventCSVOut_CLICKHandler(): void {
    // 入力チェック
    if (!this.inputCheck()) {
      return;
    }
    const vo = {
      /** 受注コード */
      orderCode: '',
      /** 画像ファイル名リスト */
      imageFileNameList: []
    };
    // VO設定
    vo.orderCode = this.kymw6100Model.orderCode;
    vo.imageFileNameList = PlessViewUtilsSub.trim(this.kymw6100Model.fileNameList).split('\n');

    if (this.kymw6100Model.radioGroup === '1') {     // 画像指示一覧表出力の場合
      // API呼び出し
      this.getCwsUseImageInfoService.execute(this.kymw6100Model, vo, (data: any) => {
        // ファイル名の設定
        const fileName = 'EC画像指示一覧表_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.tsv';
        this.fileDownloadConfirmService.show(data.FileName, fileName);
      });
    } else {                                          // 画像ファイル出力の場合
      // API呼び出し
      this.putImageFileService.execute(this.kymw6100Model, vo);
    }
  }

  /**
   *  画面情報の初期化
   */
  public initKYMW6100(): void {
    // 受注コードをクリアに連動して、配達企画回（翌週）がクリアされる。
    this.kymw6100Model.orderCode = '';
    // 出力区分（画像指示一覧表）
    this.kymw6100Model.radioGroup = '1';
    // 画像ファイル名リスト
    this.kymw6100Model.fileNameList = '';
    // 活性・非活性制御
    this.plessEnabled(this.txti_OrderCode, true);
    this.plessEnabled(this.txta_FileNameList, false);
  }

  /**
   * メニュー「最新の情報に更新」押下時の処理
   *
   */
  public reloadKYMW6100(): void {
    this.initKYMW6100();
  }

  /**
   * 入力チェック
   *
   * @return true:OK false:NG
   */
  public inputCheck(): boolean {
    if (this.kymw6100Model.radioGroup === '1') {  // 画像指示一覧表出力の場合
      // 受注コード必須チェック
      if (PlessViewUtilsSub.isEmpty(this.kymw6100Model.orderCode)) {
        this.dialogService.openAlertGetMessage('E0110', ['受注コード']);
        return false;
      }
      // 受注コード存在チェック
      if (PlessViewUtilsSub.isEmpty(this.txti_OrderCode.selectedCatalogID)) {
        this.dialogService.openAlertGetMessage('E0122', ['受注コード']);
        return false;
      }
    } else {                                        // 画像ファイル出力の場合
      // 画像ファイル名リスト必須チェック
      if (PlessViewUtilsSub.isEmpty(this.kymw6100Model.fileNameList)) {
        this.dialogService.openAlertGetMessage('E0143');
        return false;
      }
    }
    return true;
  }
}
